// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ydH2","type":"styles_type__32xW4","choices":"styles_choices__2vO1W"};